<template>
  <card>
    <list
      v-if="$store.state.user.is_root"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "section",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "imeis",
      setLink: "imeis",
      columns: [
        {
          key: "number",
          title: "IMEI",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          title: "Товар",
          key: "product",
          object: "name",
        },
        {
          key: "main",
          title: "IMEI (MAIN)",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          title: "Дата загрузки",
          key: "created_at",
          dateTimeFormat: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
